import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    InputSignal,
    output,
    OutputEmitterRef,
    Signal
} from "@angular/core";
import {ContentMessageComponent} from "../../notification/message/content-message.component";
import {MessageLayout, MessageLevel} from "../../notification/message/message";
import {NotificationService} from "../../notification/notification.service";
import {DealModel} from "../deal.model";
import {DealData} from "../deal-entity.model";
import {TranslateModule} from '@ngx-translate/core';
import {HtmlPipe} from '../../utils/html.pipe';

@Component({
    selector: "woa-applied-deals-panel",
    templateUrl: "./applied-deals-panel.component.html",
    styleUrl: "./applied-deals-panel.component.scss",
    imports: [
        ContentMessageComponent,
        HtmlPipe,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppliedDealsPanelComponent {
    public dealModel: DealModel = inject(DealModel);
    private notificationService: NotificationService = inject(NotificationService);

    MessageLevel = MessageLevel;
    MessageLayout = MessageLayout;

    public readonly divided: InputSignal<boolean> = input<boolean>(false);
    public readonly hideTitle: InputSignal<boolean> = input<boolean>(false);
    public readonly hideMessage: InputSignal<boolean> = input<boolean>(false);

    public dealRemoved: OutputEmitterRef<DealData> = output<DealData>();
    public readonly dealsMessage: Signal<string> = computed(() =>
        this.hideMessage() || !this.dealModel.appliedDeals().length || !this.dealModel.dealCodesAvailable() || !this.dealModel.dealLimit() ? undefined
            : this.dealModel.dealLimit() == 1 ? "woa.message.deals.single"
                : this.dealModel.dealLimitReached() ? "woa.message.deals.limitReached"
                    : "woa.message.deals.limit");

    async removeDeal(deal: DealData): Promise<void> {
        if (deal.products && deal.products.length &&
            !await this.notificationService.displayConfirmation("woa.heading.order.confirmRemoveDeal", undefined, "woa.message.order.confirmRemoveDeal",
                "woa.button.common.noThanks", "woa.button.deals.removeDeal", true)) {
            return;
        }
        this.dealModel.removeDeal(deal);
        this.dealRemoved.emit(deal);
    }
}
